var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "simple-form col-2 flex" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.specificAccVoucherInfo.no))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.specificAccVoucherInfo.servicerName))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(3),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.specificAccVoucherInfo.retailerComName))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(4),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.specificAccVoucherInfo.creatorName))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(5),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.specificAccVoucherInfo.createTime))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(6),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(
                _vm._s(_vm.applyStateMap[_vm.specificAccVoucherInfo.applyState])
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(7),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.specificAccVoucherInfo.applicantName))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(8),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.specificAccVoucherInfo.applyDesc))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(9),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.specificAccVoucherInfo.applyTime))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(10),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(
                _vm._s(_vm.auditStateMap[_vm.specificAccVoucherInfo.auditState])
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(11),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.specificAccVoucherInfo.auditorName))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(12),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.specificAccVoucherInfo.auditDesc))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(13),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.specificAccVoucherInfo.auditTime))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(14),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.specificAccVoucherInfo.sentFlag ? "已发货" : "待发货"
                )
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(15),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.specificAccVoucherInfo.sentActorName))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(16),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.specificAccVoucherInfo.sentDesc))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(17),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.specificAccVoucherInfo.sentTime))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(18),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.specificAccVoucherInfo.recvFlag ? "已收货" : "待收货"
                )
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(19),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.specificAccVoucherInfo.recvActorName))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(20),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.specificAccVoucherInfo.recvDesc))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(21),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.specificAccVoucherInfo.recvTime))])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [
          _vm._v("返修单项"),
          _c("span", { staticClass: "font-orange" }, [
            _vm._v(
              "【共" +
                _vm._s(_vm.renterComCount()) +
                "个配件提供商，" +
                _vm._s(
                  (_vm.specificAccVoucherInfo.specificAccRepairItems || [])
                    .length
                ) +
                "个配件】"
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: (
              _vm.specificAccVoucherInfo.specificAccRepairItems || []
            ).slice(
              (_vm.pageNumber - 1) * _vm.pageSize,
              _vm.pageNumber * _vm.pageSize
            ),
            border: ""
          }
        },
        [
          _c("el-table-column", {
            attrs: {
              width: "200",
              align: "left",
              prop: "srcServicerName",
              label: "服务商"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              width: "200",
              align: "left",
              prop: "srcWarehouseName",
              label: "原出库仓库"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              width: "200",
              align: "left",
              prop: "name",
              label: "配件名称"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              width: "120",
              align: "left",
              prop: "catName",
              label: "分类"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              width: "120",
              align: "left",
              prop: "brandName",
              label: "品牌"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              width: "180",
              align: "left",
              prop: "modelSpec",
              label: "规格"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              width: "150",
              align: "left",
              prop: "vendorSn",
              label: "厂商序列号"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              width: "150",
              align: "left",
              prop: "boundDevcName",
              label: "设备名称"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "left", prop: "faultDesc", label: "故障说明" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-layout" },
        [
          _vm.totalCount > 0
            ? _c("el-pagination", {
                attrs: {
                  background: "",
                  "page-size": _vm.pageSize,
                  "page-sizes": _vm.pageSizes,
                  "current-page": _vm.pageNumber,
                  total: _vm.totalCount,
                  layout: "prev, pager, next, jumper, sizes, total"
                },
                on: {
                  "current-change": _vm.handlePageChange,
                  "size-change": _vm.handleSizeChange
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("返修单信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("返修单号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("服务商")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("业务单元")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("创建人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("创建时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("申请状态")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("申请人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("申请描述")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("申请时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("审核状态")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("审核人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("审核描述")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("审核时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("已发货")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("发货标记人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("发货备注")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("发货时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("已收货")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("收货标记人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("收货备注")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("收货时间")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3425ea38", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3425ea38","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/accStock/SpecificAccRepairVoucherDetail.vue
// module id = 2840
// module chunks = 0